export function pad(num: number, size: number = 3) {
  const str = "00" + num;
  return str.slice(-size);
}
